import React from "react";
import "./transportType.css";

const TransportType = ({ indent }) => {
  const dropType = indent?.indent_info?.drop;

  return (
    <div className="transport-container">
      {/* Drop Type Label - Top Left Corner */}
      <div style={{ marginBottom: "15px", fontSize: "15px", fontWeight: "600", color: "#7a7777", marginLeft: "15px" }}>
        TripType: <span style={{ fontWeight: "600", color: "#393185", fontSize: "15px" }}>
          {dropType === "multidrop" ? "MultiDrop" : dropType === "oneway" ? "OneWay" : dropType === "roundtrip" ? "RoundTrip" : "OneWay"}
        </span>
      </div>

      {/* MULTIDROP */}
      {dropType === "multidrop" ? (
        <div>
          <div className="route-card">
            <div className="address-row">
              {/* Loading */}
              <div className="address-item">
                <span className="address-heading">Loading Address</span>
                <div className="address-main">
                  {indent?.indent_info?.origin?.addressLine1 ?? "NA"}
                </div>
                <div className="address-sub">
                  {indent?.indent_info?.origin?.location?.suggestion ?? "NA"}
                </div>

              </div>

              {/* Arrow */}
              <div className="arrow-container">
                <span className="arrow">&#8594;</span>
              </div>

              {/* Final Unloading */}
              <div className="address-item text-right">
                <span className="address-heading">Final Unloading Address</span>
                <div className="address-main">
                  {indent?.indent_info?.destination?.addressLine1 ?? "NA"}
                </div>
                <div className="address-sub">
                  {indent?.indent_info?.destination?.location?.suggestion ?? "NA"}
                </div>

              </div>
            </div>
          </div>

          {/* Unloading list */}
          <div className="unloading-section">
            <div className="unloading-heading">Unloading Addresses</div>

            {indent?.indent_info?.drop_locations?.map((dropLocation, index) => (
              <div key={dropLocation?.id} className="unloading-item">
                <span className="unloading-number">{index + 1}.</span>
                <span className="unloading-number">{dropLocation?.drop_location?.addressLine1 ?? "NA"}</span>,<span>{dropLocation?.drop_location?.location_name ?? "NA"}</span>
              </div>
            ))}
          </div>
        </div>
      ) : dropType === "oneway" ? (
        /* ONEWAY */
        <div className="route-card">
          <div className="address-row">
            <div className="address-item">
              <span className="address-heading">Loading Address</span>
              <div className="address-main">
                {indent?.indent_info?.origin?.location_name ?? "NA"}
              </div>
            </div>

            <div className="arrow-container">
              <span className="arrow">&#8594;</span>
            </div>

            <div className="address-item text-right">
              <span className="address-heading">Unloading Address</span>
              <div className="address-main">
                {indent?.indent_info?.destination?.location_name ?? "NA"}
              </div>
            </div>
          </div>
        </div>
      ) : dropType === "roundtrip" ? (

        /* ROUNDTRIP */
        <div>
          <div className="route-card">
            <div className="address-row">
              <div className="address-item">
                <span className="address-heading">Pickup Address</span>


                <div className="address-sub">
                  <div className="address-main">
                    {indent?.indent_info?.origin?.addressLine1 ?? ""}
                  </div>
                  {indent?.indent_info?.origin?.location?.suggestion ??
                    indent?.indent_info?.origin?.location_name ??
                    "NA"}
                </div>

              </div>

              <div className="arrow-container">
                <span className="arrow">&#8594;</span>
              </div>

              <div className="address-item text-right">
                <span className="address-heading">Drop Address</span>

                <div className="address-sub">
                  <div className="address-main">
                    {indent?.indent_info?.destination?.addressLine1 ?? ""}
                  </div>
                  {indent?.indent_info?.destination?.location?.suggestion ??
                    indent?.indent_info?.destination?.location_name ??
                    "NA"}
                </div>

              </div>
            </div>
          </div>
          <div className="route-card">
            <div className="address-row">
              <div className="address-item">
                <span className="address-heading">Drop Address</span>


                <div className="address-sub">
                  <div className="address-main">
                    {indent?.indent_info?.origin?.addressLine1 ?? ""}
                  </div>
                  {indent?.indent_info?.origin?.location?.suggestion ??
                    indent?.indent_info?.origin?.location_name ??
                    "NA"}
                </div>

              </div>

              <div className="arrow-container">
                <span className="arrow">⟵</span>
              </div>

              <div className="address-item text-right">
                <span className="address-heading">Pickup Address</span>

                <div className="address-sub">
                  <div className="address-main">
                    {indent?.indent_info?.destination?.addressLine1 ?? ""}
                  </div>
                  {indent?.indent_info?.destination?.location?.suggestion ??
                    indent?.indent_info?.destination?.location_name ??
                    "NA"}
                </div>

              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="route-card">
          <div className="address-row">
            <div className="address-item">
              <span className="address-heading">Pickup Address</span>


              <div className="address-main">

                {indent?.indent_info?.origin?.location?.suggestion ??
                  indent?.indent_info?.origin?.location_name ??
                  "NA"}
              </div>

            </div>

            <div className="arrow-container">
              <span className="arrow">&#8594;</span>
            </div>

            <div className="address-item text-right">
              <span className="address-heading">Drop Address</span>

              <div className="address-main">

                {indent?.indent_info?.destination?.location?.suggestion ??
                  indent?.indent_info?.destination?.location_name ??
                  "NA"}
              </div>

            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TransportType;
